<template>
  <panel class="channel-overview-ct">
    <div class="header">
      <icon class="icon" :glyph="`dashboard_${channelName}`" />
      <h3>{{ $t(channelLabels[channelName]) }}</h3>
    </div>

    <div class="metrics">
      <template v-for="(metric, index) in metrics">
        <metric
          :key="index"
          :title="
            metricLabels.hasOwnProperty(metric.name)
              ? $t(metricLabels[metric.name])
              : metric.name
          "
          :metric="metric.value"
          :type="metric.type"
          class="metric"
        />
      </template>
    </div>
  </panel>
</template>

<script>
import Panel from '@/common/components/Panel'
import Metric from '@/common/components/Metric'
import {
  channelLabels,
  metricLabels
} from '@/common/components/dashboard/Labels'

export default {
  name: 'ChannelOverview',

  components: { Panel, Metric },

  props: {
    channelName: {
      type: String,
      required: true
    },
    metrics: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      channelLabels,
      metricLabels
    }
  }
}
</script>

<style scoped>
.channel-overview-ct {
  width: 536px;
}

>>> .el-card__body {
  padding-bottom: 0;
}

.metrics {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.metrics .metric {
  margin-bottom: 20px;
  height: 52px;
  flex-basis: 33%;
}

.header {
  display: flex;
  align-items: center;
  padding-bottom: 24px;
}

h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #1d87c8;
  display: inline-block;
}

.icon {
  width: 32px;
  height: 32px;
  margin-right: 18px;
}

.icon >>> svg {
  color: #1d87c8;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ChannelOverview.vue